import { sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';

export function getDeviceByKey(deviceKey) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_device_by_key',
        device_key: deviceKey
      })
    }
  );
}



// WEBPACK FOOTER //
// ./src/services/devices.js